import React, { useState, useEffect } from 'react';
import './GestionEquiposColaborativos.scss';
import telimanData from '../../dataset_teliman.json';

const GestionEquiposColaborativos = () => {
  const [usuariosActivos, setUsuariosActivos] = useState([]);
  const [equiposCreados, setEquiposCreados] = useState([]);
  const [proyectoActivo, setProyectoActivo] = useState(null);
  const [mensajesEquipo, setMensajesEquipo] = useState([]);
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState(null);
  const [mostrarCrearEquipo, setMostrarCrearEquipo] = useState(false);
  const [mostrarFlujoTrabajo, setMostrarFlujoTrabajo] = useState(false);
  const [tareasCompartidas, setTareasCompartidas] = useState([]);
  const [recursosCompartidos, setRecursosCompartidos] = useState([]);

  // Inicializar datos
  useEffect(() => {
    // Cargar usuarios de TELIMAN como usuarios activos
    const usuariosTeliman = telimanData.usuarios.slice(0, 40); // Primeros 40 para la demo
    setUsuariosActivos(usuariosTeliman);

    // Crear equipos de ejemplo
    const equiposEjemplo = [
      {
        id: 1,
        nombre: 'Equipo Seguridad Hospitalaria',
        descripcion: 'Gestión de servicios en hospitales',
        miembros: telimanData.usuarios.slice(0, 10),
        color: '#4CAF50',
        proyectos: ['Proyecto Hospital Perpetuo', 'Optimización Turnos'],
        activo: true
      },
      {
        id: 2,
        nombre: 'Equipo Innovación Digital',
        descripcion: 'Desarrollo de herramientas digitales',
        miembros: telimanData.usuarios.slice(10, 18),
        color: '#2196F3',
        proyectos: ['Kit Digital', 'Profiling Sistema'],
        activo: true
      },
      {
        id: 3,
        nombre: 'Equipo Formación',
        descripcion: 'Capacitación y recursos compartidos',
        miembros: telimanData.usuarios.slice(18, 28),
        color: '#FF9800',
        proyectos: ['Plan Formación 2025', 'Base Conocimiento'],
        activo: false
      },
      {
        id: 4,
        nombre: 'Equipo Coordinación',
        descripcion: 'Planificación y resolución de problemas',
        miembros: telimanData.usuarios.slice(28, 40),
        color: '#9C27B0',
        proyectos: ['Coordinación Servicios', 'Mejora Continua'],
        activo: true
      }
    ];
    setEquiposCreados(equiposEjemplo);

    // Crear mensajes de colaboración de ejemplo
    const mensajes = [
      {
        id: 1,
        usuario: telimanData.usuarios[0],
        mensaje: '¿Alguien tiene experiencia con el nuevo sistema de turnos?',
        timestamp: '10:30',
        equipo: 'Equipo Seguridad Hospitalaria'
      },
      {
        id: 2,
        usuario: telimanData.usuarios[3],
        mensaje: 'Sí, he trabajado con él. ¿Qué necesitas?',
        timestamp: '10:32',
        equipo: 'Equipo Seguridad Hospitalaria'
      },
      {
        id: 3,
        usuario: telimanData.usuarios[10],
        mensaje: 'He compartido el documento de optimización en Recursos',
        timestamp: '11:15',
        equipo: 'Equipo Innovación Digital'
      }
    ];
    setMensajesEquipo(mensajes);

    // Tareas compartidas
    const tareas = [
      {
        id: 1,
        titulo: 'Revisar protocolo Hospital Perpetuo',
        asignadoA: [telimanData.usuarios[0], telimanData.usuarios[2]],
        estado: 'En progreso',
        prioridad: 'Alta',
        equipo: 'Equipo Seguridad Hospitalaria'
      },
      {
        id: 2,
        titulo: 'Documentar nuevas funcionalidades',
        asignadoA: [telimanData.usuarios[10], telimanData.usuarios[12]],
        estado: 'Pendiente',
        prioridad: 'Media',
        equipo: 'Equipo Innovación Digital'
      },
      {
        id: 3,
        titulo: 'Preparar sesión formativa',
        asignadoA: [telimanData.usuarios[18], telimanData.usuarios[20]],
        estado: 'Completada',
        prioridad: 'Alta',
        equipo: 'Equipo Formación'
      }
    ];
    setTareasCompartidas(tareas);

    // Recursos compartidos
    const recursos = [
      {
        id: 1,
        nombre: 'Guía Profiling Sistema.pdf',
        tipo: 'Documento',
        compartidoPor: telimanData.usuarios[10],
        fecha: '27/11/2025',
        descargas: 12
      },
      {
        id: 2,
        nombre: 'Template Cuadrantes.xlsx',
        tipo: 'Plantilla',
        compartidoPor: telimanData.usuarios[0],
        fecha: '26/11/2025',
        descargas: 8
      },
      {
        id: 3,
        nombre: 'Video: Optimización Paralela',
        tipo: 'Video',
        compartidoPor: telimanData.usuarios[12],
        fecha: '25/11/2025',
        descargas: 15
      }
    ];
    setRecursosCompartidos(recursos);

    // Seleccionar primer equipo por defecto
    setProyectoActivo(equiposEjemplo[0]);
  }, []);

  const handleSeleccionarUsuario = (usuario) => {
    setUsuarioSeleccionado(usuario);
  };

  const handleSeleccionarEquipo = (equipo) => {
    setProyectoActivo(equipo);
  };

  const handleCrearEquipo = () => {
    setMostrarCrearEquipo(true);
  };

  const handleGuardarEquipo = () => {
    // Simular creación de equipo
    const nuevoEquipo = {
      id: equiposCreados.length + 1,
      nombre: 'Nuevo Equipo Colaborativo',
      descripcion: 'Descripción del equipo',
      miembros: [],
      color: '#607D8B',
      proyectos: [],
      activo: true
    };
    setEquiposCreados([...equiposCreados, nuevoEquipo]);
    setMostrarCrearEquipo(false);
  };

  const handleAgregarMiembro = (usuario) => {
    if (proyectoActivo && !proyectoActivo.miembros.find(m => m.id === usuario.id)) {
      const equipoActualizado = {
        ...proyectoActivo,
        miembros: [...proyectoActivo.miembros, usuario]
      };
      setProyectoActivo(equipoActualizado);
      // Actualizar en la lista de equipos
      setEquiposCreados(equiposCreados.map(e => 
        e.id === equipoActualizado.id ? equipoActualizado : e
      ));
    }
  };

  const getPrioridadColor = (prioridad) => {
    switch(prioridad) {
      case 'Alta': return '#F44336';
      case 'Media': return '#FF9800';
      case 'Baja': return '#4CAF50';
      default: return '#757575';
    }
  };

  const getEstadoColor = (estado) => {
    switch(estado) {
      case 'Completada': return '#4CAF50';
      case 'En progreso': return '#2196F3';
      case 'Pendiente': return '#FF9800';
      default: return '#757575';
    }
  };

  return (
    <div className="gestion-equipos-colaborativos">
      {/* HEADER */}
      <div className="header-equipos">
        <div className="logo-section">
          <h1>🤝 Gestión Colaborativa de Equipos</h1>
          <p className="empresa-info">{telimanData.metadata.empresa_nombre} - Empresa {telimanData.metadata.empresa}</p>
        </div>
        <div className="stats-section">
          <div className="stat-card">
            <span className="stat-number">{usuariosActivos.length}</span>
            <span className="stat-label">Usuarios Activos</span>
          </div>
          <div className="stat-card">
            <span className="stat-number">{equiposCreados.length}</span>
            <span className="stat-label">Equipos Creados</span>
          </div>
          <div className="stat-card">
            <span className="stat-number">{tareasCompartidas.length}</span>
            <span className="stat-label">Tareas Compartidas</span>
          </div>
        </div>
      </div>

      {/* CONTENIDO PRINCIPAL */}
      <div className="contenido-principal">
        {/* PANEL IZQUIERDO: USUARIOS ACTIVOS */}
        <div className="panel-izquierdo">
          <div className="seccion-usuarios">
            <h2>👥 Usuarios activos</h2>
            <div className="filtros-usuarios">
              <input 
                type="text" 
                placeholder="🔍 Buscar usuario..." 
                className="input-buscar"
              />
              <select className="select-filtro">
                <option>Todos los usuarios</option>
                <option>En línea</option>
                <option>Disponibles</option>
              </select>
            </div>
            <div className="lista-usuarios">
              {usuariosActivos.map((usuario, index) => (
                <div 
                  key={usuario.id}
                  className={`usuario-item ${usuarioSeleccionado?.id === usuario.id ? 'seleccionado' : ''}`}
                  onClick={() => handleSeleccionarUsuario(usuario)}
                >
                  <div className="usuario-avatar">
                    {usuario.persona?.nombre?.charAt(0)}{usuario.persona?.apellido1?.charAt(0)}
                  </div>
                  <div className="usuario-info">
                    <span className="usuario-nombre">
                      {usuario.persona?.nombre} {usuario.persona?.apellido1} {usuario.persona?.apellido2}
                    </span>
                    <span className="usuario-email">{usuario.email}</span>
                  </div>
                  <div className={`usuario-estado ${index % 3 === 0 ? 'online' : 'offline'}`}></div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* PANEL CENTRAL: EQUIPOS Y PROYECTOS */}
        <div className="panel-central">
          {/* EQUIPOS COLABORATIVOS */}
          <div className="seccion-equipos">
            <div className="seccion-header">
              <h2>👨‍👩‍👧‍👦 Equipos Colaborativos</h2>
              <button className="btn-crear" onClick={handleCrearEquipo}>
                ➕ Crear Equipo
              </button>
            </div>
            <div className="grid-equipos">
              {equiposCreados.map(equipo => (
                <div 
                  key={equipo.id}
                  className={`equipo-card ${proyectoActivo?.id === equipo.id ? 'activo' : ''}`}
                  style={{ borderLeftColor: equipo.color }}
                  onClick={() => handleSeleccionarEquipo(equipo)}
                >
                  <div className="equipo-header">
                    <h3>{equipo.nombre}</h3>
                    <span className={`badge-estado ${equipo.activo ? 'activo' : 'inactivo'}`}>
                      {equipo.activo ? '🟢 Activo' : '⚫ Inactivo'}
                    </span>
                  </div>
                  <p className="equipo-descripcion">{equipo.descripcion}</p>
                  <div className="equipo-stats">
                    <span>👥 {equipo.miembros.length} miembros</span>
                    <span>📁 {equipo.proyectos.length} proyectos</span>
                  </div>
                  <div className="equipo-proyectos">
                    {equipo.proyectos.map((proyecto, idx) => (
                      <span key={idx} className="tag-proyecto">{proyecto}</span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* COMPARTICIÓN DE RECURSOS */}
          <div className="seccion-recursos">
            <div className="seccion-header">
              <h2>📚 Recursos Compartidos</h2>
              <button className="btn-compartir">📤 Compartir Recurso</button>
            </div>
            <div className="lista-recursos">
              {recursosCompartidos.map(recurso => (
                <div key={recurso.id} className="recurso-item">
                  <div className="recurso-icono">
                    {recurso.tipo === 'Documento' && '📄'}
                    {recurso.tipo === 'Plantilla' && '📊'}
                    {recurso.tipo === 'Video' && '🎥'}
                  </div>
                  <div className="recurso-info">
                    <span className="recurso-nombre">{recurso.nombre}</span>
                    <span className="recurso-meta">
                      Por {recurso.compartidoPor.persona?.nombre} {recurso.compartidoPor.persona?.apellido1} • {recurso.fecha}
                    </span>
                  </div>
                  <div className="recurso-acciones">
                    <span className="recurso-descargas">⬇️ {recurso.descargas}</span>
                    <button className="btn-descargar">Descargar</button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* TAREAS COLABORATIVAS */}
          <div className="seccion-tareas">
            <div className="seccion-header">
              <h2>✅ Tareas Colaborativas</h2>
              <button className="btn-nueva-tarea">➕ Nueva Tarea</button>
            </div>
            <div className="lista-tareas">
              {tareasCompartidas.map(tarea => (
                <div key={tarea.id} className="tarea-item">
                  <div className="tarea-checkbox">
                    <input 
                      type="checkbox" 
                      checked={tarea.estado === 'Completada'}
                      readOnly
                    />
                  </div>
                  <div className="tarea-contenido">
                    <div className="tarea-header">
                      <span className="tarea-titulo">{tarea.titulo}</span>
                      <span 
                        className="tarea-prioridad" 
                        style={{ backgroundColor: getPrioridadColor(tarea.prioridad) }}
                      >
                        {tarea.prioridad}
                      </span>
                    </div>
                    <div className="tarea-meta">
                      <span className="tarea-equipo">🏷️ {tarea.equipo}</span>
                      <span 
                        className="tarea-estado"
                        style={{ color: getEstadoColor(tarea.estado) }}
                      >
                        ● {tarea.estado}
                      </span>
                    </div>
                    <div className="tarea-asignados">
                      {tarea.asignadoA.map((usuario, idx) => (
                        <div key={idx} className="avatar-pequeño" title={`${usuario.persona?.nombre} ${usuario.persona?.apellido1} ${usuario.persona?.apellido2}`}>
                          {usuario.persona?.nombre?.charAt(0)}{usuario.persona?.apellido1?.charAt(0)}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* PANEL DERECHO: HERRAMIENTAS COLABORATIVAS */}
        <div className="panel-derecho">
          {/* INFORMACIÓN DEL EQUIPO ACTIVO */}
          {proyectoActivo && (
            <div className="info-equipo-activo">
              <h3 style={{ color: proyectoActivo.color }}>{proyectoActivo.nombre}</h3>
              <p>{proyectoActivo.descripcion}</p>
              
              <div className="miembros-equipo">
                <h4>Miembros del equipo ({proyectoActivo.miembros.length})</h4>
                <div className="lista-miembros">
                  {proyectoActivo.miembros.map(miembro => (
                    <div key={miembro.id} className="miembro-mini">
                      <div className="avatar-mini">
                        {miembro.persona?.nombre?.charAt(0)}{miembro.persona?.apellido1?.charAt(0)}
                      </div>
                      <span>{miembro.persona?.nombre} {miembro.persona?.apellido1}</span>
                    </div>
                  ))}
                </div>
                <button className="btn-agregar-miembro" onClick={() => usuarioSeleccionado && handleAgregarMiembro(usuarioSeleccionado)}>
                  ➕ Agregar miembro seleccionado
                </button>
              </div>
            </div>
          )}

          {/* HERRAMIENTAS DE COMUNICACIÓN */}
          <div className="herramienta-comunicacion">
            <h4>💬 Chat del Equipo</h4>
            <div className="chat-mensajes">
              {mensajesEquipo
                .filter(m => !proyectoActivo || m.equipo === proyectoActivo.nombre)
                .map(mensaje => (
                  <div key={mensaje.id} className="mensaje-item">
                    <div className="mensaje-avatar">
                      {mensaje.usuario.persona?.nombre?.charAt(0)}{mensaje.usuario.persona?.apellido1?.charAt(0)}
                    </div>
                    <div className="mensaje-contenido">
                      <div className="mensaje-header">
                        <span className="mensaje-usuario">{mensaje.usuario.persona?.nombre} {mensaje.usuario.persona?.apellido1}</span>
                        <span className="mensaje-timestamp">{mensaje.timestamp}</span>
                      </div>
                      <p className="mensaje-texto">{mensaje.mensaje}</p>
                    </div>
                  </div>
                ))}
            </div>
            <div className="chat-input">
              <input type="text" placeholder="Escribe un mensaje..." />
              <button>📨</button>
            </div>
          </div>

          {/* FLUJOS DE TRABAJO */}
          <div className="herramienta-flujos">
            <div className="seccion-header">
              <h4>⚙️ Flujos de Trabajo</h4>
              <button 
                className="btn-configurar"
                onClick={() => setMostrarFlujoTrabajo(!mostrarFlujoTrabajo)}
              >
                🔧 Configurar
              </button>
            </div>
            {mostrarFlujoTrabajo && (
              <div className="config-flujo">
                <div className="flujo-item">
                  <span>📝 Creación de tarea</span>
                  <select className="select-flujo">
                    <option>Asignación automática</option>
                    <option>Asignación manual</option>
                  </select>
                </div>
                <div className="flujo-item">
                  <span>✅ Aprobación</span>
                  <select className="select-flujo">
                    <option>Requiere supervisor</option>
                    <option>Aprobación automática</option>
                  </select>
                </div>
                <div className="flujo-item">
                  <span>🔔 Notificaciones</span>
                  <select className="select-flujo">
                    <option>Tiempo real</option>
                    <option>Resumen diario</option>
                  </select>
                </div>
                <button className="btn-guardar-flujo">💾 Guardar configuración</button>
              </div>
            )}
          </div>

          {/* IDEACIÓN Y RESOLUCIÓN DE PROBLEMAS */}
          <div className="herramienta-ideacion">
            <h4>💡 Tablero de Ideación</h4>
            <div className="ideas-tablero">
              <div className="idea-card">
                <div className="idea-header">
                  <span>💡</span>
                  <span className="idea-votos">👍 12</span>
                </div>
                <p>Optimizar sistema de registro paralelo</p>
                <span className="idea-autor">- Propuesta por {telimanData.usuarios[10].persona?.nombre}</span>
              </div>
              <div className="idea-card">
                <div className="idea-header">
                  <span>🔧</span>
                  <span className="idea-votos">👍 8</span>
                </div>
                <p>Implementar caché local de turnos</p>
                <span className="idea-autor">- Propuesta por {telimanData.usuarios[12].persona?.nombre}</span>
              </div>
              <div className="idea-card problema">
                <div className="idea-header">
                  <span>⚠️</span>
                  <span className="idea-estado">En resolución</span>
                </div>
                <p>Reducir tiempo de fetch Freematica</p>
                <span className="idea-autor">- Reportado por {telimanData.usuarios[0].persona?.nombre}</span>
              </div>
            </div>
            <button className="btn-nueva-idea">➕ Nueva idea/problema</button>
          </div>
        </div>
      </div>

      {/* MODAL CREAR EQUIPO */}
      {mostrarCrearEquipo && (
        <div className="modal-overlay" onClick={() => setMostrarCrearEquipo(false)}>
          <div className="modal-crear-equipo" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Crear Nuevo Equipo Colaborativo</h3>
              <button onClick={() => setMostrarCrearEquipo(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label>Nombre del equipo</label>
                <input type="text" placeholder="Ej: Equipo Innovación" />
              </div>
              <div className="form-group">
                <label>Descripción</label>
                <textarea placeholder="Describe el propósito del equipo..."></textarea>
              </div>
              <div className="form-group">
                <label>Color identificativo</label>
                <div className="colores-selector">
                  <div className="color-option" style={{ backgroundColor: '#4CAF50' }}></div>
                  <div className="color-option" style={{ backgroundColor: '#2196F3' }}></div>
                  <div className="color-option" style={{ backgroundColor: '#FF9800' }}></div>
                  <div className="color-option" style={{ backgroundColor: '#9C27B0' }}></div>
                  <div className="color-option" style={{ backgroundColor: '#F44336' }}></div>
                </div>
              </div>
              <div className="form-group">
                <label>Miembros iniciales</label>
                <p className="form-hint">Selecciona usuarios de la lista izquierda para agregarlos</p>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn-cancelar" onClick={() => setMostrarCrearEquipo(false)}>Cancelar</button>
              <button className="btn-guardar" onClick={handleGuardarEquipo}>✅ Crear Equipo</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GestionEquiposColaborativos;


